var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgLink(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M9.2 13.599a1 1 0 011.6-1.198 4 4 0 006.033.432l2.988-2.988a4 4 0 00-.049-5.607 3.997 3.997 0 00-5.597-.059l-1.72 1.71a1 1 0 11-1.41-1.418l1.73-1.72a6 6 0 018.472 8.496l-3 3a6 6 0 01-9.048-.648zm5.6-3.198a1 1 0 11-1.6 1.198 4 4 0 00-6.033-.432L4.18 14.155a4 4 0 00.049 5.607c1.543 1.543 4.038 1.565 5.595.06l1.71-1.71a1 1 0 011.414 1.415l-1.722 1.722a6 6 0 01-8.472-8.496l3-3a6 6 0 019.048.648z"
  }));
}

export default SvgLink;